const INVITE_CODE_KEY = 'shuixin_invite_code'
const UTM_KEY = 'utm_params'
const ATTRIBUTION_SOURCE_KEY = 'shuixin_attribution_source'

const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']
export const ATTRIBUTION_SOURCE = {
  PC_INVITE: 'pc_invite',
  AD_LANDING: 'ad_landing',
  PC_ORGANIC: 'pc_organic'
}

function firstQueryValue(value) {
  if (Array.isArray(value)) return value[0]
  return value
}

export function captureAttribution(query = {}) {
  const inviteCode = firstQueryValue(query.invite_code)
  if (inviteCode && String(inviteCode).trim()) {
    localStorage.setItem(INVITE_CODE_KEY, String(inviteCode).trim().toUpperCase())
  }

  const utmData = {}
  UTM_KEYS.forEach((key) => {
    const value = firstQueryValue(query[key])
    if (value && String(value).trim()) {
      utmData[key] = String(value).trim()
    }
  })

  if (Object.keys(utmData).length > 0) {
    sessionStorage.setItem(UTM_KEY, JSON.stringify(utmData))
  }

  if (inviteCode && String(inviteCode).trim()) {
    localStorage.setItem(ATTRIBUTION_SOURCE_KEY, ATTRIBUTION_SOURCE.PC_INVITE)
  } else if (Object.keys(utmData).length > 0) {
    localStorage.setItem(ATTRIBUTION_SOURCE_KEY, ATTRIBUTION_SOURCE.AD_LANDING)
  } else if (!localStorage.getItem(ATTRIBUTION_SOURCE_KEY)) {
    localStorage.setItem(ATTRIBUTION_SOURCE_KEY, ATTRIBUTION_SOURCE.PC_ORGANIC)
  }
}

export function getStoredInviteCode() {
  return localStorage.getItem(INVITE_CODE_KEY) || ''
}

export function clearStoredInviteCode() {
  localStorage.removeItem(INVITE_CODE_KEY)
}

export function getStoredAttributionSource() {
  return localStorage.getItem(ATTRIBUTION_SOURCE_KEY) || ATTRIBUTION_SOURCE.PC_ORGANIC
}

export function clearStoredAttribution() {
  localStorage.removeItem(INVITE_CODE_KEY)
  localStorage.removeItem(ATTRIBUTION_SOURCE_KEY)
  sessionStorage.removeItem(UTM_KEY)
}

export function getStoredUtmParams() {
  try {
    return JSON.parse(sessionStorage.getItem(UTM_KEY) || '{}')
  } catch (error) {
    return {}
  }
}

export function getAttributionPayload() {
  return {
    invite_code: getStoredInviteCode() || undefined,
    attribution_source: getStoredAttributionSource(),
    utm_params: getStoredUtmParams()
  }
}
